module.exports = __webpack_public_path__ + "img/cyberconfFooter.d97f4322.svg";